import React from 'react';
import { Container, Table } from 'react-bootstrap';
import fill from '../../images/Pricing/fill.png';
import mark from '../../images/Pricing/mark.png';
import './Pricing.scss';

const Pricing = () => {
    const tableData = [
        {
            id: 1,
            fet: '10+ PAGES',
            basic: fill,
            advance: fill,
            enter: mark,
        },
        {
            id: 2,
            fet: 'RESPONSIVE DEVELOPMENT',
            basic: mark,
            advance: fill,
            enter: mark,
        },
        {
            id: 3,
            fet: 'CMS IMPLEMENTATION',
            basic: fill,
            advance: mark,
            enter: fill,
        },
        {
            id: 4,
            fet: 'E-COMMERCE',
            basic: mark,
            advance: mark,
            enter: fill,
        },
        {
            id: 5,
            fet: 'MOBILE APP',
            basic: fill,
            advance: fill,
            enter: fill,
        },
        {
            id: 6,
            fet: 'EXTENDING LIMITS',
            advance: fill,
            enter: fill,
        },
        {
            id: 7,
            fet: 'DESIGN COMPLEXITY',
            advance: fill,
            enter: mark,
        },
        {
            id: 8,
            fet: 'OWN ANALYTICS PLATFORM',
            enter: mark,
        },
    ];

    return (
        <section className="pricing">
            <Container>
                <div
                    className="text-center pricing-header"
                    data-aos="zoom-out-right"
                    data-aos-duration="2000"
                >
                    <h1>Our Pricing</h1>
                    <p>
                        No hidden cost. Your deserve to know how much your website is going to cost.
                    </p>
                </div>
                <Table
                    bordered
                    responsive
                    borderless
                    className="pricing-table"
                    data-aos="zoom-in"
                    data-aos-duration="1500"
                >
                    <thead className="table-header">
                        <tr>
                            <th>Features</th>
                            <th className="text-center">Basic</th>
                            <th className="text-center">Advance</th>
                            <th className="text-center">Enterprise</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableData.map((table) => (
                            <tr key={table.id}>
                                <td>{table.fet}</td>
                                <td className="text-center">
                                    <img src={table.basic} alt="" />
                                </td>
                                <td className="text-center">
                                    <img src={table.advance} alt="" />
                                </td>
                                <td className="text-center">
                                    <img src={table.enter} alt="" />
                                </td>
                            </tr>
                        ))}
                        <tr className="table-pricing">
                            <td>
                                <span>Price</span>{' '}
                            </td>
                            <td className="text-center">
                                from <span className="price-color">1500$</span>
                            </td>
                            <td className="text-center">
                                from <span className="price-color">3500$</span>
                            </td>
                            <td className="text-center">
                                from <span className="price-color">6000$</span>
                            </td>
                        </tr>
                        <tr className="pricing-btn">
                            <td />
                            <td className="text-center">
                                <button type="button" className="price-button">
                                    Get Started
                                </button>
                            </td>
                            <td className="text-center">
                                <button type="button" className="price-button">
                                    Get Started
                                </button>
                            </td>
                            <td className="text-center">
                                <button type="button" className="price-button">
                                    Get Started
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </Table>

                {/* Table for mobile version  */}
                <Table
                    bordered
                    responsive
                    borderless
                    className="pricing-table1"
                    data-aos="zoom-in"
                    data-aos-duration="1500"
                >
                    <thead className="table-header">
                        <tr>
                            <th>Features</th>
                            <th className="text-center">Basic</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableData.map((table) => (
                            <tr key={table.id}>
                                <td>{table.fet}</td>
                                <td className="text-center">
                                    <img src={table.basic} alt="" />
                                </td>
                            </tr>
                        ))}
                        <tr className="table-pricing">
                            <td>
                                <span>Price</span>{' '}
                            </td>
                            <td className="text-center">
                                from <span className="price-color">1500$</span>
                            </td>
                        </tr>
                    </tbody>
                </Table>
                <div
                    className="text-center pricing-table1"
                    data-aos="zoom-in"
                    data-aos-duration="1500"
                >
                    <button type="button" className="price-button">
                        Get Started
                    </button>
                </div>

                {/* Table for mobile version  */}
                <Table
                    bordered
                    responsive
                    borderless
                    className="pricing-table2 mt-5"
                    data-aos="zoom-in"
                    data-aos-duration="1500"
                >
                    <thead className="table-header">
                        <tr>
                            <th>Features</th>
                            <th className="text-center">Advance</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableData.map((table) => (
                            <tr key={table.id}>
                                <td>{table.fet}</td>
                                <td className="text-center">
                                    <img src={table.advance} alt="" />
                                </td>
                            </tr>
                        ))}
                        <tr className="table-pricing">
                            <td>
                                <span>Price</span>{' '}
                            </td>
                            <td className="text-center">
                                from <span className="price-color">1500$</span>
                            </td>
                        </tr>
                    </tbody>
                </Table>
                <div
                    className="text-center pricing-table1"
                    data-aos="zoom-in"
                    data-aos-duration="1500"
                >
                    <button type="button" className="price-button">
                        Get Started
                    </button>
                </div>

                {/* Table for mobile version  */}
                <Table
                    bordered
                    responsive
                    borderless
                    className="pricing-table3 mt-5"
                    data-aos="zoom-in"
                    data-aos-duration="1500"
                >
                    <thead className="table-header">
                        <tr>
                            <th>Features</th>
                            <th className="text-center">Enterprise</th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableData.map((table) => (
                            <tr key={table.id}>
                                <td>{table.fet}</td>
                                <td className="text-center">
                                    <img src={table.enter} alt="" />
                                </td>
                            </tr>
                        ))}
                        <tr className="table-pricing">
                            <td>
                                <span>Price</span>{' '}
                            </td>
                            <td className="text-center">
                                from <span className="price-color">1500$</span>
                            </td>
                        </tr>
                    </tbody>
                </Table>
                <div
                    className="text-center pricing-table1"
                    data-aos="zoom-in"
                    data-aos-duration="1500"
                >
                    <button type="button" className="price-button">
                        Get Started
                    </button>
                </div>
            </Container>
        </section>
    );
};

export default Pricing;
